import { render } from "./IconHome.vue?vue&type=template&id=0680f77c"
import script from "./IconHome.vue?vue&type=script&lang=ts"
export * from "./IconHome.vue?vue&type=script&lang=ts"
script.render = render

export default script